import { map } from 'rxjs/operators';

const deleteOne = (apiClient, topLevelCategoryId, localeCode, categoryConfigId) => {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/admin/browse/category-configs/${topLevelCategoryId}/${localeCode}/${categoryConfigId}`;

  return apiClient.delete(route).toPromise();
};

const fetchAllForTopLevelCategory = (apiClient, topLevelCategoryId) => {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/admin/browse/category-configs/${topLevelCategoryId}`;

  return apiClient
    .get(route)
    .pipe(
      map(response => {
        const { categoryConfigSummaryByLocaleCode } = response.data ?? {};

        return {
          categoryConfigByLocaleCode: categoryConfigSummaryByLocaleCode
        };
      })
    )
    .toPromise();
};

const fetchOne = (apiClient, topLevelCategoryId, localeCode, categoryConfigId) => {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/admin/browse/category-configs/${topLevelCategoryId}/${localeCode}/${categoryConfigId}`;

  return apiClient
    .get(route)
    .pipe(
      map(response => {
        const categoryConfig = response.data;

        return categoryConfig;
      })
    )
    .toPromise();
};

const saveOne = (apiClient, topLevelCategoryId, localeCode, categoryConfig) => {
  const { categoryConfigId } = categoryConfig;
  const isNew = !categoryConfigId;
  const method = isNew ? 'post' : 'put';

  let route = apiClient.route`/libraries/${':librarySubdomain'}/admin/browse/category-configs/${topLevelCategoryId}/${localeCode}`;
  if (!isNew) {
    route = route.concat(`/${categoryConfigId}`);
  }

  return apiClient[method](route, categoryConfig)
    .pipe(
      map(response => {
        return response.data;
      })
    )
    .toPromise();
};

export { deleteOne, fetchAllForTopLevelCategory, fetchOne, saveOne };
